"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const NotFoundPage_style_1 = require("./NotFoundPage.style");
const NotFoundPage = ({ children }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        children,
        react_1.default.createElement(NotFoundPage_style_1.PageContainer, null,
            react_1.default.createElement(NotFoundPage_style_1.ContentContainer, null,
                react_1.default.createElement(NotFoundPage_style_1.Title, null, t("notFoundPage.header")),
                react_1.default.createElement(NotFoundPage_style_1.Description, null,
                    t("notFoundPage.message"),
                    " ")))));
};
exports.NotFoundPage = NotFoundPage;
